import { render, staticRenderFns } from "./SetBlock.vue?vue&type=template&id=5f3b80db&scoped=true"
import script from "./SetBlock.vue?vue&type=script&lang=js"
export * from "./SetBlock.vue?vue&type=script&lang=js"
import style0 from "./SetBlock.vue?vue&type=style&index=0&id=5f3b80db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b80db",
  null
  
)

export default component.exports